import { formatDate, isDateValid } from 'helpers/date';
import { normalizeStr } from 'helpers/text';

export const getTravelOption = (option) => {
  let value = { icon: '', i18n: { key: '', data: null } };

  switch (normalizeStr(option.name)) {
    case normalizeStr('Formule'):
      value = { icon: 'utensils', i18n: { key: option.value, data: null } };
      break;
    case normalizeStr('Date de départ'):
      if (isDateValid(option.value)) {
        value = {
          icon: 'calendar-days',
          i18n: {
            key: 'products:departureDate',
            data: { date: formatDate(option.value, 'dd MMM yyyy') }
          }
        };
      }
      break;
    case normalizeStr('Ville de départ'):
      value = { icon: 'plane-departure', i18n: { key: 'products:departureCity', data: { city: option.value } } };
      break;
    default:
      break;
  }
  return value;
};
